<template>
  <TextBase
    is="h2"
    size="text-2xl @2xl:text-3xl"
    font="font-bold"
    color="text-gray-900"
    class="leading-7 @2xl:tracking-tight"
  >
    <slot />
  </TextBase>
</template>

<script setup>
import TextBase from './TextBase.vue'
</script>
